import { faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import { faLifeRing } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import capitalize from 'lodash-es/capitalize';
import {
    CAREER,
    CAREER_URL,
    COMMERCIAL,
    COMMERCIAL_URL,
    COOKIE_POLICY_PAGE,
    DATA_PRIVACY,
    FOLLOW_US_ON_FACEBOOK_URL,
    FOOTER_CODEX_LINK,
    FOOTER_CONTACT,
    FOOTER_DOWNLOAD_ON_APP_STORE,
    FOOTER_DOWNLOAD_ON_GOOGLE_PLAY,
    FOOTER_HELP_LINK,
    PRIVACY_AND_COOKIE_POLICY,
    RULES_BAZAAR,
    RULES_COMMON,
    STROLLER_STROLLEROPEDIA,
} from 'mk/autogenerated/translations/Footer.5700874da4a028bf48998c89be203e5e'
import assetUrl from 'mk/common/assetUrl';
import { ACTIVE_SERVER_ID, BASE_URL } from 'mk/settings';
import {
    aboutContactUrl,
    aboutCookiePolicyUrl,
    aboutPrivacyAndCookiePolicyUrl,
    aboutPrivacyPolicyUrl,
    aboutRulesCodexUrl,
    aboutRulesCommonUrl,
    aboutRulesMarketUrl,
} from 'mk2/apps/about/urls';
import { faqRootUrl } from 'mk2/apps/faq/urls';
import { strollersUrl } from 'mk2/apps/strollers/urls';
import Img from 'mk2/components/Img';
import Link from 'mk2/components/Link';
import InstallPrompt from 'mk2/containers/InstallPrompt/InstallPrompt';
import React from 'react';
import styles from './Footer.mscss';

interface OwnProps {
}

export class Footer extends React.PureComponent<OwnProps> {

    public render() {
        if (ACTIVE_SERVER_ID === 207) {
            const p = BASE_URL.split('.');
            const niceUrl = capitalize(p[p.length - 2] + '.' + p[p.length - 1]);

            return (
                <div className={cx(styles.Footer, styles.Footer_sb)}>
                    <div className={cx(styles.Footer__footer, styles.Footer__footer_sb)}>
                        <div className={styles.Footer__links}>
                            <ul className={cx(styles.Footer__links_row, styles.Footer__links_row_sb)}>
                                <li>
                                    <a href={strollersUrl}>{niceUrl}</a>
                                </li>
                                <li>
                                    <Link to={aboutPrivacyAndCookiePolicyUrl}>
                                        {PRIVACY_AND_COOKIE_POLICY}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div
                className={cx(
                    styles.Footer,
                    styles.Footer__hideOnMobile,
                )}
            >
                <div className={styles.Footer__help}>
                    <div className={styles.Footer__links}>
                        <ul className={styles.Footer__links_row}>
                            <li>
                                <FontAwesomeIcon icon={faLifeRing} className={styles.Footer__lifering} />&nbsp;
                                <Link to={faqRootUrl}>{FOOTER_HELP_LINK}</Link>
                            </li>
                            <li>
                                <Link to={aboutRulesCodexUrl}>{FOOTER_CODEX_LINK}</Link>
                            </li>
                            <li>
                                <Link to={aboutRulesMarketUrl}>{RULES_BAZAAR}</Link>
                            </li>
                            <li>
                                <Link to={aboutRulesCommonUrl}>{RULES_COMMON}</Link>
                            </li>
                            <li>
                                <Link to={aboutContactUrl}>{FOOTER_CONTACT}</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className={styles.Footer__footer}>
                    <div className={styles.Footer__links}>
                        <ul className={styles.Footer__links_row}>
                            <li>
                                <a href={COMMERCIAL_URL} target="_blank" rel="noopener">{COMMERCIAL}</a>
                            </li>
                            <li>
                                <a href={CAREER_URL} target="_blank" rel="noopener">{CAREER}</a>
                            </li>
                            <li>
                                <Link to={aboutCookiePolicyUrl}>{COOKIE_POLICY_PAGE}</Link>
                            </li>
                            <li>
                                <Link to={aboutPrivacyPolicyUrl}>{DATA_PRIVACY}</Link>
                            </li>
                            <li>
                                <a href={strollersUrl}>{STROLLER_STROLLEROPEDIA}</a>
                            </li>
                        </ul>
                    </div>

                    <div className={styles.Footer__apps}>
                        <a className={styles.Footer__apps__app} href="https://www.youtube.com/c/Modrykonik">
                            <Img width={58} height={40} src={`${assetUrl}img/3rd-party/big-youtube.png`} />
                        </a>
                        <a className={styles.Footer__apps__app} href={FOLLOW_US_ON_FACEBOOK_URL}>
                            <Img width={40} height={40} src={`${assetUrl}img/3rd-party/big-facebook.png`} />
                        </a>
                        <a className={styles.Footer__apps__app} href="https://www.instagram.com/modrykonik/">
                            <Img width={40} height={40} src={`${assetUrl}img/3rd-party/big-instagram.png`} />
                        </a>
                        <div className={styles.Footer__apps__bull}>•</div>
                        <InstallPrompt className={styles.Footer__apps__app} />
                        <a className={styles.Footer__apps__app} href={`https://play.google.com/store/apps/details?id=com.modrykonik.mk.${ACTIVE_SERVER_ID === 201 ? 'sk' : 'cz'}`} target="_blank">
                            <Img width={135} height={40} src={`${assetUrl}img/misc/google_play_app_${ACTIVE_SERVER_ID}@2x.png`} alt={FOOTER_DOWNLOAD_ON_GOOGLE_PLAY} />
                        </a>
                        <div className={styles.Footer__apps__bull}>•</div>
                        <FontAwesomeIcon
                            className={styles.Footer__apps__cc}
                            icon={faCcVisa}
                            size="2x"
                            />
                        <FontAwesomeIcon
                            className={styles.Footer__apps__cc}
                            icon={faCcMastercard}
                            size="2x"
                        />
                    </div>
                </div>
            </div>
        );
    }
}
